<template>
  <div class="container py-14">
    <DpplSvg
      class="logo"
      file-name="datapeople-logo"
      alt="Datapeople icon"
    />
    <img
      v-if="graphicPath.includes('http')"
      class="graphic"
      :src="graphicPath"
      alt="Gradient"
    >
    <DpplPng
      v-else
      class="graphic"
      :file-name="graphicPath"
    />
  </div>
</template>

<script>
import DpplPng from '@/components/datapeople/DpplPng.vue';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';

export default {
  name: 'WizardGradientSideBar',
  components: {
    DpplPng,
    DpplSvg,
  },
  props: {
    graphicPath: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  min-height: inherit;
  background: linear-gradient(180deg, @white 9.39%, @bg-canvas 98.38%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.logo {
  margin-bottom: 120px;
  display: block;
  width: 160px;
  max-width: 100%;
}

.graphic {
  max-height: 200px;
  max-width: 200px;
}
</style>
